import 'simplelightbox/dist/simple-lightbox.min.css';

import SimpleLightbox from 'simplelightbox';

export default {
    init() {
        const lightbox = new SimpleLightbox('.zoomable');
        lightbox.on('error.simplelightbox', (e) => {
            // eslint-disable-next-line no-console
            console.error('erreur lightbox', e);
        });
    },
};
